import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../services/customer/customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer } from '../../models/customer.model';
import { Subject, takeUntil } from 'rxjs';
import { CommonService } from '../../services/shared/common/common.service';
import { AppStateService } from '../../services/shared/app-state/app-state.service';

@Component({
  selector: 'app-page-resolver',
  templateUrl: './page-resolver.component.html',
  styleUrl: './page-resolver.component.css'
})
export class PageResolverComponent implements OnInit {

  private destroy$ = new Subject<void>();

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    public common: CommonService,
    public appState: AppStateService,
  ) {}

  customerId?: string;
  ngOnInit(){
    this.route.paramMap.subscribe(params => {
      this.customerId = params.get('customerId')!;
      this.resolve();
    });
  }

  resolve(): boolean {
    if (this.customerId) {
      this.customerService.getFirstAvailablePageUrl(this.customerId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (endpoint: string | null) => {
          if (endpoint && endpoint.length > 0) {
            const newEndPoint = this.router.parseUrl(endpoint);
            if (this.appState.getIsEmbed()) {
              newEndPoint.queryParams['embed'] = 'true';
            }
            this.router.navigateByUrl(newEndPoint);
            return true;
          }
          this.router.navigate(['']);
          return false;
        },
        error: (error) => {
          this.router.navigate(['']);
          return false;
        }
      });
    }
    return false;
  }
}
